export const getAcceptedFileExtensions = (extensions: string[]) =>
  extensions.map((extension) => `.${extension}`).join(", ");
